import { Box, Typography } from '@material-ui/core'
import { LocalShipping, Payment, PersonOutline } from '@material-ui/icons'
import React from 'react'
import { strings as Localization } from '../../lib/Localization'
import { useUser, useUserData } from '../../redux/hook/userHooks'
import useStyles from './styles'

const UserInfo = () => {
    const user = useUser()
    const userData = useUserData()
    const classes = useStyles()

    return (
        <Box>
            <Box className={classes.flexColumn}>
                <PersonOutline />
                <Typography variant='body1'>
                    {Localization.customerNumber}
                </Typography>
                <Typography variant='body2' className={classes.marginBottom1}>
                    {userData.customerNumber}
                </Typography>
                <Typography variant='body1'>
                    {Localization.email}
                </Typography>
                <Typography variant='body2' className={classes.marginBottom1}>
                    {userData.email}
                </Typography>
                <Typography variant='body1'>
                    {Localization.name}
                </Typography>
                {
                    userData.name &&
                    <Typography variant='body2'>
                        {userData.name}
                    </Typography>
                }
            </Box>
            <Box className={classes.flexColumn}>
                {user.addresses &&
                    <>
                        {user.addresses.deliveryAddress &&
                            <Box className={classes.flexColumn}>
                                <LocalShipping />
                                <Typography className={classes.capitalized}>{Localization.standardShippingAddress}</Typography>
                                <Typography variant='caption'>{user.addresses.deliveryAddress.Row1}</Typography>
                                <Typography variant='caption'>{user.addresses.deliveryAddress.Row2}</Typography>
                                <Typography variant='caption'>{user.addresses.deliveryAddress.Row4}</Typography>
                            </Box>
                        }
                        {user.addresses.invoiceAddress &&
                            <Box className={classes.flexColumn}>
                                <Payment />
                                <Typography className={classes.capitalized}>{Localization.billingAddress}</Typography>
                                <Typography variant='caption'>{user.addresses.invoiceAddress.Row1}</Typography>
                                <Typography variant='caption'>{user.addresses.invoiceAddress.Row2}</Typography>
                                <Typography variant='caption'>{user.addresses.invoiceAddress.Row4}</Typography>
                            </Box>
                        }
                    </>
                }
            </Box>
        </Box>
    )
}

export default UserInfo
